<script>
import _ from "lodash";
import { mapStores } from "pinia";
import {useAssetsStore} from "@/stores/assets.js";

export default {
  name: "SelectAssetDropdown",
  props: {
    disabled: Boolean,
    modelValue: null,
    assetFilters: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      assetParams: {
        filter: {
          search: null,
          company_id: undefined,
        },
        force_include_id: this.modelValue,
        per_page: 100
      },
      loadingAssets: true,
    };
  },
  computed: {
    ...mapStores(useAssetsStore),
  },
  watch: {
    modelValue(newValue, oldValue) {
      this.assetParams.force_include_id = newValue;
    },
    assetFilters: {
      handler: function(newValue, oldValue) {
        if(_.isEqual(newValue, oldValue)){
          return;
        }

        this.$nextTick(() => {
          this.assetParams.filter = {
            search: this.assetParams.filter.search,
            ...newValue
          }
          this.loadData();
        })
      },
      immediate: true,
    }
  },
  methods: {
    onSearch: _.debounce(
        function (value) {
          this.assetParams.filter.search = value?.length ? value : undefined;
          this.loadData();
        },
        1000
    ),
    async loadData(){
      this.loadingAssets = true;
      await this.assetsStore.indexAssetOptions(this.assetParams, false);
      this.loadingAssets = false;
    },
  },
}
</script>

<template>
  <Dropdown
      class="flex-1"
      :model-value="modelValue"
      @update:model-value="value => $emit('update:modelValue', value)"
      :options="assetsStore.getAssetOptions"
      option-label="name"
      option-value="id"
      :virtualScrollerOptions="{ itemSize: 38 }"
      :filter="true"
      :disabled="disabled || loadingAssets"
      @filter="onSearch($event.value)"
      :loading="loadingAssets"
      :show-clear="!disabled"
      :emptyMessage='loadingAssets ? "Loading Assets..." : "No available assets"'
      :emptyFilterMessage='loadingAssets ? "Loading Assets..." : "No available assets"'
      data-cy="asset-value"
  />
</template>

<style scoped>

</style>